// extracted by mini-css-extract-plugin
var _1 = "WidgetFrame-module_widget_blue__yYsPeM";
var _2 = "WidgetFrame-module_widget_burgundy__USYT2j";
var _3 = "WidgetFrame-module_widget_custom__Y6Y8Cu";
var _4 = "WidgetFrame-module_widget_danger__ISipfE";
var _5 = "WidgetFrame-module_widget_default__kQzvtY";
var _6 = "WidgetFrame-module_widget_green__esk2eM";
var _7 = "WidgetFrame-module_widget_header__Om0oG9";
var _8 = "WidgetFrame-module_widget_icon__Lo8fhD";
var _9 = "WidgetFrame-module_widget_magenta__ctis1x";
var _a = "WidgetFrame-module_widget_menu__vsdYtJ";
var _b = "WidgetFrame-module_widget_menu_container__HrdJrz";
var _c = "WidgetFrame-module_widget_menu_dropdown__MFN_rn";
var _d = "WidgetFrame-module_widget_menu_icon__ci4otM";
var _e = "WidgetFrame-module_widget_none__LqyUoh";
var _f = "WidgetFrame-module_widget_primary__x5TFPf";
var _10 = "WidgetFrame-module_widget_title__L2Ogif";
var _11 = "WidgetFrame-module_widget_yellow__uVmWGv";
export { _1 as "widget_blue", _2 as "widget_burgundy", _3 as "widget_custom", _4 as "widget_danger", _5 as "widget_default", _6 as "widget_green", _7 as "widget_header", _8 as "widget_icon", _9 as "widget_magenta", _a as "widget_menu", _b as "widget_menu_container", _c as "widget_menu_dropdown", _d as "widget_menu_icon", _e as "widget_none", _f as "widget_primary", _10 as "widget_title", _11 as "widget_yellow" }
